import Colors from './colors'

export default {
  color: Colors.Palette.whiteColor,
  fontWeight: 700,
  textDecoration: 'underline'
}



// WEBPACK FOOTER //
// ./src/theme/pwa-refresh.js